import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
query loanControlsWithPagination($page: Int, $perPage: Int, $filters: FiltersLoanControl) {
  loanControlsWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        mothers_last_name
        document_number
      }
      date
      date_start_discount
      amount
      dues
      cuotasg
      frequency
      reason
      status
      status_text
      balance
      history {
        id
        loan_control_id
        fee
        date
        amount
        tipo
        status
        status_text
        tipotext
      }
    }
  }
}
`

const GET_ALL = gql`
  query loanControls ($filters: FiltersLoanControl) {
    loanControls (filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
      }
      date
      date_start_discount
      amount
      dues
      cuotasg
      frequency
      reason
      status
      status_text
      balance
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createLoanControl ($input: LoanControlForm!) {
    createLoanControl (input: $input) {
      id
    }
  }
`

const UPDATE = gql`
  mutation updateLoanControl ($id: ID!, $input: LoanControlForm!) {
    updateLoanControl (id: $id, input: $input) {
      id
    }
  }
`

const UPDATE_HISTORY = gql`
  mutation updateHistoryLoanControl ($id: ID!, $input: HistoryLoanControlInput!) {
    updateHistoryLoanControl (id: $id, input: $input) {
      id
    }
  }
`

const DELETE = gql`
  mutation deleteLoanControl ($id: ID!) {
    deleteLoanControl(id: $id) { 
      id
    }
  }
`

const VALIDATE_LOAN_CONTROL = gql`
  mutation validateLoanControl ($id: ID, $input: LoanControlForm!) {
    validateLoanControl (id: $id, input: $input) {
      success
      msgError
    }
  }
`

export {
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    GET_ALL,
    UPDATE_HISTORY,
    VALIDATE_LOAN_CONTROL
}
